import { axiosDelete, axiosGet, axiosPatch, axiosPost } from './axios.helpers';

export const getServices = async (
  pageNumber,
  pageSize,
  subLocationId,
  schedulerId,
) => {
  const subLocationSuffix = subLocationId
    ? `&filter[sub_location]=${subLocationId}`
    : '';
  const schedulerSuffix = schedulerId ? `&filter[schedule]=${schedulerId}` : '';

  return axiosGet(
    `/services?page[number]=${
      pageNumber + 1
    }&page[size]=${pageSize}${subLocationSuffix}${schedulerSuffix}`,
  );
};

export const getService = async (id) => axiosGet(`/services/${id}`);

export const updateService = async (id, service) => {
  const { name, duration, equipmentType } = service;

  await axiosPatch(`/services/${id}`, {
    name,
    default_duration: duration,
    equipment_type: equipmentType,
  });
};

export const createService = async (service) => {
  const { name, duration, equipmentType } = service;

  await axiosPost('/services', {
    name,
    default_duration: duration,
    equipment_type: equipmentType,
  });
};

export const deleteService = async (id) => {
  await axiosDelete(`/services/${id}`);
};
